import { formatCurrency } from "./SCRV2InvoiceDetailHelpers";
import { formatScrV2TransactionCount } from "./SCRV2SummaryReportComponents";

export const ScrV2PrintPanel = ({ title, badge, children }) => (
  <div className="scr-v2-print-panel">
    <div className="scr-v2-print-panel__header">
      <span className="scr-v2-print-panel__title">{title}</span>
      {badge ? <span className="scr-v2-print-panel__badge">{badge}</span> : null}
    </div>
    <div className="scr-v2-print-panel__body">{children}</div>
  </div>
);

export const ScrV2PrintAmountRow = ({ label, value, deduct, signed, strong, highlight }) => {
  const amount = Number(value || 0);

  const renderValue = () => {
    if (signed) {
      if (amount < 0) {
        return <span className="scr-v2-print-text-danger">- {formatCurrency(amount)}</span>;
      }
      if (amount > 0) {
        return <span className="scr-v2-print-text-success">+ {formatCurrency(amount)}</span>;
      }
      return <strong>{formatCurrency(0)}</strong>;
    }

    if (deduct) {
      return <span className="scr-v2-print-text-danger">- {formatCurrency(amount)}</span>;
    }

    return (
      <strong className={highlight ? "scr-v2-print-text-primary" : undefined}>
        {formatCurrency(amount)}
      </strong>
    );
  };

  return (
    <div className={`scr-v2-print-amount-row${strong ? " scr-v2-print-amount-row--strong" : ""}`}>
      <span
        className={`scr-v2-print-amount-row__label${
          strong ? " scr-v2-print-amount-row__label--strong" : ""
        }`}
      >
        {label}
      </span>
      <span className="scr-v2-print-amount-row__value">{renderValue()}</span>
    </div>
  );
};

export const ScrV2PrintAmountRows = ({ children }) => (
  <div className="scr-v2-print-amount-rows">{children}</div>
);

export const ScrV2PrintKpi = ({ title, amount, detail }) => (
  <div className="scr-v2-print-kpi">
    <div className="scr-v2-print-kpi__header">
      <div className="scr-v2-print-kpi__title">{title}</div>
      {detail ? <div className="scr-v2-print-kpi__detail">{detail}</div> : null}
    </div>
    <div className="scr-v2-print-kpi__amount">{amount}</div>
  </div>
);

export const ScrV2PrintPaymentGroup = ({ title, amount, count, children }) => (
  <>
    <tr className="scr-v2-print-payment-group">
      <td>{title}</td>
      <td>{formatScrV2TransactionCount(count)}</td>
      <td>{formatCurrency(amount)}</td>
    </tr>
    {children}
  </>
);

export const ScrV2PrintPaymentRow = ({ label, count, amount, indent = false }) => (
  <tr className={indent ? "scr-v2-print-payment-child" : undefined}>
    <td>{label}</td>
    <td>{formatScrV2TransactionCount(count)}</td>
    <td>{formatCurrency(amount)}</td>
  </tr>
);
